import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IndividualConfig, ToastrService } from "ngx-toastr";
import { EzDialogComponent } from '@template-ui/components/ez-dialog/ez-dialog.component';
import { EzDialogData, IEzDialogComponent } from "@template-ui/types";

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  defaultTimeout = 3000;
  constructor(
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  showSuccess(message: string, title: string = "Success", timeout: number = this.defaultTimeout): void {
    this.toastr.success(message, title, {
      timeOut: timeout,
      disableTimeOut: false,
    });
  }

  showSuccessWithConfig(message: string, title: string = "Success", config?: Partial<IndividualConfig>): void {
    const _config = {...{timeOut: this.defaultTimeout, disableTimeOut: false }, ...config};
    this.toastr.success(message, title, _config);
  }

  showSuccessWithClose(message: string, title: string = "Success"): void {
    this.toastr.success(message, title, {
      closeButton: true,
    });
  }

  showInformation(message: string, title: string = "Information", timeout: number = this.defaultTimeout): void {
    this.toastr.info(message, title, {
      timeOut: timeout,
      disableTimeOut: false,
    });
  }

  showInformationWithClose(message: string, title: string = "Information"): void {
    this.toastr.info(message, title, {
      closeButton: true,
    });
  }

  showError(message: string, title: string = "Error", timeout: number = this.defaultTimeout): void {
    this.toastr.error(message, title, {
      timeOut: timeout,
      disableTimeOut: false,
      positionClass: 'toast-top-center'
    });
  }

  showErrorWithConfig(message: string, title: string = "Error", config?: Partial<IndividualConfig>): void {
    const _config = {...{timeOut: this.defaultTimeout, disableTimeOut: false, positionClass: 'toast-top-center' }, ...config};
    this.toastr.error(message, title, _config);
  }

  showApiError(error: any) {
    if (error.error.Status >= 400 && error.error.Status < 500) {
      this.showError(error.error.Message, error.error.Title);
    } else {
      this.showMessageDialog(error.error.Message, error.error.Title);
    }
  }

  showErrorWithClose(message: string, title: string = "Error"): void {
    this.toastr.error(message, title, {
      closeButton: true,
      positionClass: 'toast-top-center'
    });
  }

  showMessageDialog(message: string, title: string = "Error", headerStyle: "info" | "warning" | "error" = "error"): void {
    const content = this.getErrorModel();
    content.content = message;
    content.heading = title;
    content.headerStyle = headerStyle;

    this.dialog.open(EzDialogComponent, {
      width: "40%",
      data: { ...content },
    });
  }

  private getErrorModel(): EzDialogData {
    return {
      heading: "",
      question: "",
      headerStyle: "error",
      content: "",
      useForm: false,
      formActions: [],
      config: [],
      buttons: [
        {
          text: "Ok",
          action: (ref: MatDialogRef<IEzDialogComponent>) => {
            ref.close();
          },
        },
      ],
    };
  }
}
